import { RatioTypeEnum } from 'gql/graphql';

import type { TCheckedIds } from './types';

export const ratioNames: Record<RatioTypeEnum, string> = {
    [RatioTypeEnum.ConstraintCoef]: 'Коэффициент особых условий',
    [RatioTypeEnum.TechPartCoef]: 'Коэффициент технической части',
    [RatioTypeEnum.DismantlingCoef]: 'Коэффициент на демонтаж',
};

export const defaultCheckedIdsState: TCheckedIds = {
    [RatioTypeEnum.ConstraintCoef]: {},
    [RatioTypeEnum.TechPartCoef]: {},
    [RatioTypeEnum.DismantlingCoef]: {},
};

export const ratioTypesSelectItems = [
    {
        id: RatioTypeEnum.ConstraintCoef,
        label: ratioNames[RatioTypeEnum.ConstraintCoef],
    },
    {
        id: RatioTypeEnum.TechPartCoef,
        label: ratioNames[RatioTypeEnum.TechPartCoef],
    },
    {
        id: RatioTypeEnum.DismantlingCoef,
        label: ratioNames[RatioTypeEnum.DismantlingCoef],
    },
];

export const defaultColDefSet = {
    sortable: true,
    comparator: () => 0,
};
